import { render, staticRenderFns } from "./SALink.html?vue&type=template&id=03e0c424&scoped=true&"
import script from "./SALink.ts?vue&type=script&lang=ts&"
export * from "./SALink.ts?vue&type=script&lang=ts&"
import style0 from "./SALink.css?vue&type=style&index=0&id=03e0c424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e0c424",
  null
  
)

export default component.exports